import { useStaticQuery, graphql } from "gatsby"
export const useRelatedPosts = () => {
  const data = useStaticQuery(
    graphql`
      query RelatedPosts {
        allWpBlog {
            edges {
              node {
                id
                title
                link
                date(formatString: "Do MMMM YYYY")
                blogCats {
                  nodes {
                    slug
                    link
                    name
                  }
                }
                acf_customFeaturedImage {
                  customFeaturedImage {
                    altText
                    localFile {
                      childImageSharp {
                        fluid {
                          base64
                          srcWebp
                          srcSetWebp
                          originalImg
                          originalName
                        }
                      }
                    }
                  }
                }
                author {
                  node {
                    avatar {
                      url
                    }
                    name
                    firstName
                    uri
                  }
                }
              }
            }
          }
      }
    `
  )
  return data.allWpBlog
}